var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-tags"},_vm._l((_vm.value),function(tag){return _c('div',{key:tag.id,staticClass:"m-tags__tag"},[_vm._v(" "+_vm._s(tag.name)+" "),_c('a-button',{attrs:{"icon":"CloseSmall"},on:{"click":function($event){$event.preventDefault();return _vm.removeElement(tag.id)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }